var React = require('react');

function ArrowDown (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M3.89997 12L5.49997 10.375L10.85 15.725L10.85 3.89999L13.15 3.89999L13.15 15.725L18.5 10.375L20.1 12L12 20.1L3.89997 12Z","fill":"currentColor"}));
}

ArrowDown.defaultProps = {"viewBox":"0 0 24 24","fill":"none"};

module.exports = ArrowDown;

ArrowDown.default = ArrowDown;
